import TransactionsBox from './components/TransactionsBox';
import SubmitModal from './components/modals/TransactionsCreateModal';
import PageArea from '../../components/shared/PageArea';
import { TransactionsProvider } from './contexts/TransactionsContext';
import TransactionTopArea from './components/TransactionTopArea';

const StockCountSchedule = () => {


  return (
    <TransactionsProvider>
      <PageArea>
        <TransactionTopArea />
        <TransactionsBox />
        <SubmitModal></SubmitModal>
      </PageArea>
    </TransactionsProvider>
  );

};

export default StockCountSchedule;